/**
 * Devuelve una copia del objeto.
 * Se hace una copia completa y recursiva. (es decir copia los objetos dentro de objetos y array ...)
 * - Solo copia los valores, No copia los prototypes ...
 * - Por defecto, no copia los `Symbol` (es un requerimiento, así podemos usarlos para referencias circulares)
 *
 * > Ojo con referencias circulares, dara error `Maximum callstack...`
 * > Una referencia circular es cuando una propiedad del objeto se referencia a si misma o otra del objeto,
 * > lo tipico es una referencia al `parent`
 *
 * @param {object} o el objeto que queremos duplicar
 * @param {object} [options] conjunto de opciones/flags
 * @param {object} [options.symbol = false] si true, se copiaran los Symbol también
 *
 * @return {object} un nuevo objeto con los mismos valores
 */

export function clone(o, options = {}) {
  if (typeof o !== 'object' || o === null) {
    return o;
  } // Nota: typeof null === 'object'

  if (Array.isArray(o)) {
    return o.reduce((acc, cur) => [...acc, clone(cur, options)], []);
  }

  if (o instanceof Date) {
    return new Date(o.toISOString());
  }

  if (o instanceof File) {
    return new File([o], o.name, { type: o.type });
  }

  const keys = options?.symbol ? Reflect.ownKeys(o) : Object.keys(o);
  return keys.reduce((acc, cur) => {
    acc[cur] = clone(o[cur], options);
    return acc;
  }, {});
}
